import { client } from "../client";
import * as path from "../paths";

// Create a new report
export const createReport = (
  username,
  reason,
  additionalInfo = "",
  postId = null
) => {
  return client
    .post(path.CREATE_REPORT, { username, reason, additionalInfo, postId })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

// Get all reports (admin only)
export const getAllReports = (resolved = undefined, page = 1, limit = 20) => {
  let url = `${path.GET_ALL_REPORTS}?page=${page}&limit=${limit}`;
  if (resolved !== undefined) {
    url += `&resolved=${resolved}`;
  }
  return client
    .get(url)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

// Mark report as resolved (admin only)
export const markReportAsResolved = (id) => {
  return client
    .patch(`${path.UPDATE_REPORT_STATUS}${id}/resolve`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

// Delete report (admin only)
export const deleteReport = (id) => {
  return client
    .delete(`${path.DELETE_REPORT}${id}`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
